import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { ReceiptVerificationForm } from "../components/ReceiptVerificationForm";
import { SuccessfulVerification } from "./SuccessfulVerification";


export const ReceiptManagement = () => {

  const subheader = useSubheader();
  subheader.setTitle("Receipt Management");
  
  return (
    <>
      <div className="row">
        <div className="col-12">
          <Switch>
            <Redirect
              from="/receipt-management"
              exact={true}
              to="/receipt-management/receipt-search-form"
            />
            <Route
              path="/receipt-management/successful-verification"
              component={SuccessfulVerification}
            />
            <Route
              path="/receipt-management/receipt-search-form"
              component={ReceiptVerificationForm}
            />
          </Switch>
        </div>
      </div>
    </>
  );
};
